export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://docs.microsoft.com/en-us/exchange/clients-and-mobile-in-exchange-online/exchange-activesync/mobile-device-mailbox-policies';
